import React from "react";
import PublicShell from "../components/PublicShell";
import { ShieldCheck } from "lucide-react";

const GOOGLE_POLICY_URL = "https://developers.google.com/terms/api-services-user-data-policy";
const CONTACT_EMAIL = "imdad.company.admin@gmail.com";

const sections = [
  {
    title: "أولاً: المبادئ العامة",
    items: [
      "تجمع منصة إمداد البيانات التي يقدمها التاجر عند إنشاء الحساب واستخدام المنصة، وذلك لتشغيل الحساب وتقديم خدمات المنصة.",
      "عند استخدام ميزة «التوريد الخارجي»، يمكن للتاجر اختيار ربط حساب Gmail الخاص به بإمداد من خلال Google. يتم الربط بعد موافقة التاجر عبر Google، ولا تطلب منصة إمداد كلمة مرور Gmail الخاصة بالتاجر.",
      "تستخدم إمداد صلاحيات Gmail المرتبطة بميزة «التوريد الخارجي» فقط لتمكين الوظائف التي يطلبها التاجر، مثل إرسال رسائل البريد إلى الموردين، وقراءة الردود والمرفقات المرتبطة بمحادثات التوريد التي تتم متابعتها داخل إمداد.",
      "لا يجوز للوكيل إرسال رسالة أو رد إلى مورد إلا عندما يعطي التاجر أمراً صريحاً بالإرسال أو الرد.",
      "لا يتم استخدام ربط Gmail لقراءة البريد العام للتاجر بشكل عشوائي. تتم متابعة خيوط البريد المرتبطة بعمليات التوريد الخارجي التي بدأها التاجر من خلال إمداد.",
      "بيانات ربط Gmail ورموز الوصول الخاصة به تتم معالجتها وحمايتها على خوادم إمداد، ولا يتم عرض رموز الوصول للتجار الآخرين أو للموردين.",
      "يمكن للتاجر فصل حساب Gmail عن إمداد من خلال خيار فصل الربط المتاح في ميزة التوريد الخارجي.",
      "تستخدم إمداد البيانات اللازمة لتشغيل خدمات المنصة والتواصل مع المستخدم وتقديم الإشعارات والوظائف التي يطلبها داخل المنصة.",
      "باستخدام منصة إمداد، يوافق المستخدم على سياسة الخصوصية هذه ضمن نطاق استخدام خدمات المنصة.",
    ],
  },
  {
    title: "ثانياً: البيانات التي تجمعها إمداد عند استخدام المنصة",
    items: [
      "بيانات الحساب التي يقدمها التاجر: الاسم، اسم المتجر، البريد الإلكتروني، رقم الهاتف، والموقع/المدينة.",
      "المحتوى الذي يرفعه التاجر بنفسه داخل المنصة: صور المنتجات وبياناتها، الفواتير، الحجوزات، والرسائل المتبادلة مع التجار الآخرين أو إدارة المنصة.",
      "بيانات تقنية أساسية لازمة لتشغيل الخدمة وحماية الحساب، مثل بيانات تسجيل الدخول والإشعارات داخل المنصة.",
    ],
  },
  {
    title: "ثالثاً: بيانات Google / Gmail التي تصل إليها إمداد ولماذا",
    intro: "لا يُطلب ربط Gmail إلا عند اختيار التاجر استخدام ميزة «التوريد الخارجي». عند الربط تطلب إمداد من Google الأذونات التالية فقط:",
    items: [
      "عنوان البريد الإلكتروني الأساسي لحساب Google (openid / email): لعرض الحساب المربوط للتاجر والتحقق منه.",
      "إرسال البريد باسم التاجر (gmail.send): لإرسال رسائل التوريد التي يأمر بها التاجر صراحةً إلى الموردين من بريده الخاص.",
      "قراءة البريد (gmail.readonly): لقراءة ردود الموردين ومرفقاتها فقط داخل خيوط البريد التي أرسلها وكيل التوريد من حساب التاجر، عبر فحص دوري لتلك الخيوط تحديداً، دون فحص صندوق الوارد العام أو أي رسائل أخرى للتاجر.",
      "تتم متابعة خيوط بريد التوريد المتعقَّبة لرصد ردود الموردين لمدة تصل إلى 90 يوماً من تاريخ إرسال الرسالة الأصلية.",
    ],
  },
  {
    title: "رابعاً: كيفية استخدام بيانات Gmail",
    items: [
      "تُستخدم ردود الموردين ومرفقاتهم لتلخيصها للتاجر بالعربية، واستخراج المعلومات التجارية الواردة فيها (مثل الأسعار والشروط)، ومقارنة عروض الموردين داخل محادثة التوريد نفسها، وإشعار التاجر بوصول رد جديد.",
      "لا تُستخدم بيانات Gmail لأي غرض آخر؛ لا للإعلانات، ولا لبناء ملفات تعريف، ولا لتدريب نماذج ذكاء اصطناعي.",
      "يُحتفظ داخل إمداد بنص ردود الموردين، وموضوع الرسالة وعنوان المرسِل، والمعلومات التجارية المستخرجة، كجزء من سجل محادثة التوريد الخاصة بالتاجر.",
      "مرفقات الموردين (PDF وExcel وCSV) تتم معالجتها في ذاكرة الخادم لاستخراج نصها فقط، ولا يُحتفظ بملفاتها؛ يُحفظ اسم الملف ونوعه وحجمه وحالة التحليل فقط.",
    ],
  },
  {
    title: "خامساً: المعالجة بالذكاء الاصطناعي ومزوّدو الخدمة",
    items: [
      "OpenAI: تُرسَل محتويات ردود الموردين، والنص المستخرج من مرفقاتهم، ونصوص رسائل التوريد الصادرة إلى مزوّد نماذج الذكاء الاصطناعي OpenAI لتنفيذ التلخيص والاستخراج والمقارنة الخاصة بمراسلات التوريد فقط.",
      "Resend: تُرسَل رسائل الإشعارات (مثل إشعار وصول رد من مورد) إلى بريد التاجر عبر مزوّد البريد Resend، وتتضمن ملخصاً مختصراً فقط دون المحتوى الكامل لبريد المورد.",
      "لا يحصل أي من هذين المزوّدَين على رموز وصول Gmail (OAuth tokens) الخاصة بالتاجر ولا على أي صلاحية دخول مباشر إلى حساب Gmail الخاص به.",
    ],
  },
  {
    title: "سادساً: تخزين رموز الوصول والأمان",
    items: [
      "تُخزَّن رموز الوصول والتحديث الخاصة بـ Google مشفّرةً على خوادم إمداد، وتُستخدم من الخادم فقط لتنفيذ العمليات المذكورة أعلاه.",
      "لا تُعرض هذه الرموز في متصفح التاجر، ولا للتجار الآخرين، ولا للموردين، ولا لمزوّدي الخدمة.",
      "لا تحتفظ إمداد بكلمة مرور حساب Google الخاص بالتاجر ولا تطلبها في أي وقت.",
    ],
  },
  {
    title: "سابعاً: الاحتفاظ بالبيانات والحذف وفصل الربط",
    items: [
      "عند فصل Gmail من داخل ميزة «التوريد الخارجي» تقوم إمداد بإلغاء صلاحية الرمز لدى Google وحذف رموز الوصول وبيانات الربط من خوادمها فوراً.",
      "تبقى سجلات محادثات التوريد (الرسائل المرسلة، وملخصات ردود الموردين، والمقارنات) ضمن سجل حساب التاجر داخل إمداد لاستمرار مرجعيتها، ويمكن للتاجر طلب حذفها مع حذف حسابه عبر التواصل معنا.",
      "يمكن للتاجر أيضاً سحب إذن إمداد في أي وقت من إعدادات حساب Google الخاص به (صفحة الأذونات في حساب Google).",
    ],
  },
  {
    title: "ثامناً: مشاركة البيانات وبيعها",
    items: [
      "لا تبيع إمداد بيانات المستخدمين ولا بيانات Google الخاصة بهم لأي طرف.",
      "لا تُشارك هذه البيانات مع أطراف ثالثة إلا مع مزوّدي الخدمة المذكورين في هذه السياسة وبالقدر اللازم لتقديم الوظيفة التي يطلبها التاجر، أو عند وجود إلزام قانوني.",
    ],
  },
  {
    title: "تاسعاً: الالتزام بسياسة بيانات مستخدمي خدمات Google API",
    items: [
      "يلتزم استخدام إمداد للمعلومات المستلمة من Google APIs، ونقلها إلى أي تطبيق آخر، بسياسة بيانات مستخدمي خدمات Google API (Google API Services User Data Policy)، بما في ذلك متطلبات الاستخدام المحدود (Limited Use).",
    ],
    link: { label: "Google API Services User Data Policy", href: GOOGLE_POLICY_URL },
  },
  {
    title: "عاشراً: التواصل بشأن الخصوصية",
    items: [
      "لأي استفسار أو طلب يتعلق بالخصوصية أو ببيانات Gmail المرتبطة بحسابك، يمكنك التواصل معنا عبر البريد الإلكتروني أدناه أو من خلال صفحة «اتصل بنا».",
    ],
    email: CONTACT_EMAIL,
  },
  {
    title: "حادي عشر: التغييرات على هذه السياسة",
    items: [
      "تُنشر أي تعديلات على سياسة الخصوصية في هذه الصفحة مع تحديث تاريخ آخر تحديث المذكور أدناه.",
    ],
  },
];

const PrivacyPolicy = () => (
  <PublicShell>
    <section className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-testid="privacy-policy-page">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-[#7AB2B2] text-xs font-bold text-[#09637E] mb-5">
        <ShieldCheck size={14} /> السياسات
      </div>
      <h1 className="text-4xl md:text-5xl font-extrabold text-[#333333] mb-3">سياسة الخصوصية</h1>
      <p className="text-[#666666] text-base md:text-lg mb-8">
        توضّح هذه السياسة البيانات التي تجمعها منصة إمداد، وكيفية استخدامها وحمايتها، وتفاصيل الوصول إلى بيانات Google / Gmail عند استخدام ميزة «التوريد الخارجي».
      </p>
      <div className="space-y-6">
        {sections.map((s, si) => (
          <div key={s.title} className="bg-white border border-[#7AB2B2] rounded-2xl p-6 md:p-8 text-[#333333] leading-loose" data-testid={`privacy-section-${si + 1}`}>
            <h2 className="text-base md:text-lg font-extrabold text-[#09637E] mb-4">{s.title}</h2>
            {s.intro && <p className="text-base md:text-lg mb-4">{s.intro}</p>}
            <div className="space-y-4">
              {s.items.map((p, i) => (
                <p key={p.slice(0, 40)} className="text-base md:text-lg" data-testid={`privacy-item-${si + 1}-${i + 1}`}>
                  <span className="inline-block w-7 h-7 rounded-full bg-[#09637E] text-white text-sm font-extrabold ml-3 text-center leading-7 align-middle">{i + 1}</span>
                  {p}
                </p>
              ))}
            </div>
            {s.link && (
              <p className="mt-4 text-base">
                <a href={s.link.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center min-h-[44px] px-1 text-[#09637E] font-bold underline break-all" dir="ltr" data-testid="privacy-google-policy-link">
                  {s.link.label}
                </a>
              </p>
            )}
            {s.email && (
              <p className="mt-4 text-base md:text-lg">
                البريد الإلكتروني للخصوصية:{" "}
                <a href={`mailto:${s.email}`} className="inline-flex items-center min-h-[44px] px-1 text-[#09637E] font-bold underline break-all" dir="ltr" data-testid="privacy-contact-email">{s.email}</a>
              </p>
            )}
          </div>
        ))}
      </div>
      <p className="text-center text-[#666666] text-sm mt-6" data-testid="privacy-last-updated">آخر تحديث: سبتمبر 2026</p>
    </section>
  </PublicShell>
);

export default PrivacyPolicy;
